'use strict';

import {settings} from '../../variables.js'
var angularTemplatesBase = settings.angularTemplatesBase
var staticBase = settings.staticBase
var apiBaseUrl = settings.apiBaseUrl


angular.
    module('shop')

    .service('CartService', ['ShopCart', function (ShopCart) {
        var shop_cart = ShopCart.get(function () {

        });

        return {
            getCart: function () {
                return shop_cart;
            },
            setCart: function (cart) {
                shop_cart = cart;
            }
        };
    }])

    .service('CompareCartService', ['CompareCart', function (CompareCart) {
        var shop_cart = CompareCart.get(function () {});
        return {
            getCart: function () {
                return shop_cart;
            },
            setCart: function (cart) {
                shop_cart = cart;
            }
        };
    }])

    .controller('AddComponentsToCartCtrl', ['$scope', 'ShopCart', 'CartService', function ($scope, ShopCart, CartService) {
        var self = $scope;

        self.selected_summary = 0;
        self.shop_cart = CartService.getCart();
        self.action_template = 'start';
        self.message = false;

        self.go_to_start = function(){
            self.action_template = 'start';
            for (var key in self.selected_components) {
                self.selected_components[key]['selected'] = false;
                self.selected_components[key].quantity = 0;
            }
            self.selected_summary = 0;
        }

        self.get_summary = function(){
            var summary = 0;
            for (var key in self.selected_components) {
                if (self.selected_components[key]['selected']){
                    if(self.selected_components[key].quantity < 1) {
                        self.selected_components[key].quantity = 1;
                    }
                    summary += self.selected_components[key]['price'] * self.selected_components[key].quantity;
                }
                else{
                    self.selected_components[key].quantity = 0;
                }
            }
            self.selected_summary = summary;
        };

        self.add_counts = function(item){
            item.quantity++;

            self.message = false;

            if (!item['selected']) {
                item['selected'] = true;
            }

            if(item['product_id'] == 1319){
                self.add_counts(self.selected_components['variation_2596']);
                self.message = 'Комплект Г-образного крепежа стойки был добавлен в заказ автоматически';
            }
            if(item['product_id'] == 1336){
                self.add_counts(self.selected_components['variation_2596']);
                self.message = 'Комплект Г-образного крепежа стойки был добавлен в заказ автоматически';
            }
            if(item['product_id'] == 1354){
                self.add_counts(self.selected_components['variation_2596']);
                self.message = 'Комплект Г-образного крепежа стойки был добавлен в заказ автоматически';
            }

            self.get_summary();
        }

        self.delete_counts = function(item){
            item.quantity--;
            if (item.quantity < 1){
                item.quantity = 0;
                item['selected'] = false;
            }
            self.get_summary();
        }

        self.selected_components = {};

        self.add_to_cart = function () {

            var items_to_add = [];

            for (var key in self.selected_components){
                if(self.selected_components[key]['selected']) {
                    items_to_add.push({
                        cart: self.shop_cart.id,
                        content_type: self.selected_components[key].content_type,
                        object_id: self.selected_components[key].object_id,
                        quantity: self.selected_components[key].quantity
                    });
                }
            }

            self.shop_cart.items = items_to_add;

            self.shop_cart.$save(
                function (response, response_status) {
                    CartService.setCart(response);
                    self.action_template = 'complete';
                    ym(44803777, 'reachGoal', 'ADD_TO_CART');
                },
                function (response, response_status) {

                }
            );

        }

        self.set_check = function (variation_pk) {

            if (self.selected_components[variation_pk]['selected']) {
                self.selected_components[variation_pk]['selected'] = false;
            }
            else {
                self.selected_components[variation_pk]['selected'] = true;
            }
        }


    }])

    .controller('AddToCartListCtrl', ['$scope', 'ShopCart', 'CartService', 'CompareCartService', '$document', '$uibModal', function ($scope, ShopCart, CartService, CompareCartService, $document, $uibModal) {
        var self = $scope;

        self.shop_cart = CartService.getCart();
         self.compare_cart = CompareCartService.getCart();

         self.add_to_compare = function(content_type, object_id){

             var index = content_type + '_' + object_id;

             var item = {
                 cart: self.compare_cart.id,
                 content_type: content_type,
                 object_id: object_id,
                 quantity: 1
             }

             self.compare_cart.items = Array(item);

             self.compare_cart.$save(
                 function (response, response_status) {
                     CompareCartService.setCart(response);
                     self.products[index].compare_action_template = 'complete';
                     },
                 function (response, response_status) {

                 }
                 );
         }

        self.add_to_cart = function (content_type, object_id, quantity) {
            var index = content_type + '_' + object_id;
            var item = {
                cart: self.shop_cart.id,
                content_type: content_type,
                object_id: object_id,
                quantity: quantity
            }

            self.shop_cart.items = Array(item);

            self.shop_cart.$save(
                function (response, response_status) {
                    CartService.setCart(response);
                    self.products[index].action_template = 'complete';
                    ym(44803777, 'reachGoal', 'ADD_TO_CART');
                },
                function (response, response_status) {

                }
            );
        }

        self.show_product_modal = function(variation_id){
                var parentElem = angular.element($document[0].querySelector('body'));
                var modalInstance = $uibModal.open({
                    animation: this.animationsEnabled,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: angularTemplatesBase+'shop/product-modal.template.html?7',
                    controller: 'VariationModalCtrl',
                    controllerAs: '$ctrl',
                    windowClass: 'modal product-modal fade',
                    appendTo: parentElem,
                    resolve: {
                        variation_id: variation_id
                    }
                });
         }

    }])

    .controller('VariationModalCtrl', ['$uibModalInstance', 'CartService', 'CompareCartService', 'Variation', 'variation_id', function ($uibModalInstance, CartService, CompareCartService, Variation, variation_id) {
            var self = this;
            self.action_template = 'add';
            self.product_count = 1;
            self.shop_cart = CartService.getCart();
            self.compare_cart = CompareCartService.getCart();

            self.staticBase = staticBase;
            self.apiBaseUrl = apiBaseUrl

             self.add_to_compare = function(content_type, object_id){

                 var index = content_type + '_' + object_id;

                 var item = {
                     cart: self.compare_cart.id,
                     content_type: content_type,
                     object_id: object_id,
                     quantity: 1
                 }

                 self.compare_cart.items = Array(item);

                 self.compare_cart.$save(
                     function (response, response_status) {
                         CompareCartService.setCart(response);
                         self.products[index].compare_action_template = 'complete';
                         },
                     function (response, response_status) {

                     }
                     );
             }

            self.add_to_cart = function(content_type, object_id, quantity){
                var item = {
                    cart: self.shop_cart.id,
                    content_type: content_type,
                    object_id: object_id,
                    quantity: quantity
                }

                self.shop_cart.items = Array(item);

                self.shop_cart.$save(
                    function(response, response_status){
                        CartService.setCart(response);
                        self.action_template = 'complete';
                    },
                    function(response, response_status){

                    }
                );
            }

            self.variation = Variation.get({objectId: variation_id}, function(){});

            self.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            self.show_cart_modal = function(){
                CartService.show_cart_modal();
            }
    }])

    .controller('AddToCartCtrl', ['$scope', 'ShopCart', 'CartService', 'CompareCartService', function ($scope, ShopCart, CartService, CompareCartService) {
        var self = $scope;

        self.shop_cart = CartService.getCart();

        self.product_count = 1;
         self.compare_action_template = 'default';
         self.compare_cart = CompareCartService.getCart();

         self.add_to_compare = function(content_type, object_id){
             var item = {
                 cart: self.compare_cart.id,
                 content_type: content_type,
                 object_id: object_id,
                 quantity: 1
             }

             self.compare_cart.items = Array(item);

             self.compare_cart.$save(
                 function (response, response_status) {
                     CompareCartService.setCart(response);
                     self.compare_action_template = 'complete';
                     },
                 function (response, response_status) {

                 }
                 );
         }

        self.add_counts = function (count) {
            self.product_count = self.product_count + parseInt(count);
        }
        self.remove_counts = function (count) {
            self.product_count = self.product_count - parseInt(count);
            if (self.product_count < 1) {
                self.product_count = 1;
            }
        }

        self.add_to_cart = function (content_type, object_id, quantity) {
            var item = {
                cart: self.shop_cart.id,
                content_type: content_type,
                object_id: object_id,
                quantity: quantity
            }

            self.shop_cart.items = Array(item);

            self.shop_cart.$save(
                function (response, response_status) {
                    CartService.setCart(response);
                    self.action_template = 'complete';
                    ym(44803777, 'reachGoal', 'ADD_TO_CART');
                },
                function (response, response_status) {

                }
            );
        }
    }])

    .component('cart', {
        templateUrl: angularTemplatesBase+'shop/cart.template.html?3',
        controller: ['$routeParams', '$location', '$cookies', 'ShopCart', 'CartService', function CartCtrl($routeParams, $location, $cookies, ShopCart, CartService) {
            var self = this;
            self.staticBase = staticBase;
            self.shop_cart = CartService.getCart();
        }]
    })

    .component('cartpage', {
        templateUrl: angularTemplatesBase+'shop/cart_page.template.html?v=4',
        controller: ['$routeParams', '$location', '$cookies', 'ShopCart', 'CartService', 'OrderShop', 'PromoCode', function CartPageCtrl($routeParams, $location, $cookies, ShopCart, CartService, OrderShop, PromoCode) {
            var self = this;
            self.shop_cart = CartService.getCart();
            self.add_counts = function (item, count) {
                item.quantity = parseInt(item.quantity) + parseInt(count);
                self.shop_cart.$update(function (response, code) {
                    CartService.setCart(response);
                }, function (response, code) {
                });
            }
            self.update_cart_calc = function (item) {
                if (item.quantity < 1) {
                    item.quantity = 1;
                }
                self.shop_cart.$update(function (response, code) {
                    CartService.setCart(response);
                }, function (response, code) {
                });
            }
            self.delete_counts = function (item, count) {
                item.quantity = parseInt(item.quantity) - parseInt(count);
                if (item.quantity < 1) {
                    item.quantity = 1;
                }
                self.shop_cart.$update(function (response, code) {
                    CartService.setCart(response);
                }, function (response, code) {
                });
            }
            self.delete_item = function (item) {
                var index_del = -1;
                for (var i = 0; i < self.shop_cart.items.length; i++) {
                    if (self.shop_cart.items[i].object_id == item.object_id) {
                        index_del = i;
                        continue;
                    }
                }
                if (index_del > -1) {
                    self.shop_cart.items.splice(index_del, 1);
                }
                self.shop_cart.$update(function (response, code) {
                    CartService.setCart(response);
                }, function (response, code) {
                });
            }
            self.get_code = function(){
                self.errors_promo = {};
                if (self.shop_cart.promo_code) {
                    console.log(self.shop_cart.promo_code);
                    var promo_code = PromoCode.get({code: self.shop_cart.promo_code}, function(response){
                        if(promo_code.code){
                            self.shop_cart.promo_code = promo_code.code;
                            self.shop_cart.$update({update:'promo_code'},
                                function(response, response_status){
                                    CartService.setCart(response);
                                },
                                function(response, response_status){

                                }
                            );
                        }
                        else{
                            self.errors_promo = {
                                code: ['Не найден такой код']
                            }
                        }
                    })
                }else{
                    self.errors_promo = {
                        code: ['Введите код']
                    }
                }
            }
        }]
    })
    .component('checkpage', {
        templateUrl: angularTemplatesBase+'shop/check_page.template.html?7',
        controller: ['$routeParams', '$location', '$cookies', '$window', 'ShopCart', 'CartService', 'OrderShop', 'Delivery', 'Payment', function CheckPageCtrl($routeParams, $location, $cookies, $window, ShopCart, CartService, OrderShop, Delivery, Payment) {
            var self = this;
            self.shop_cart = CartService.getCart();
            self.deliveries = Delivery.query();
            self.payments = Payment.query();

            self.desabled_btn = false;
            self.btn_text = 'Отправить заказ';
            self.order = OrderShop.get({}, function () {
                self.order.cart = self.shop_cart.id;
                self.order.summary = self.shop_cart.summary;
                self.order_summary = numberWithCommas(parseInt(self.shop_cart.summary));
            })

            self.calculate = function () {
                for (var i = 0; i < self.deliveries.length; i++) {
                    if (self.deliveries[i].id == self.order.delivery) {
                        self.order_summary = numberWithCommas(parseInt(self.shop_cart.summary) + parseInt(self.deliveries[i].calculate_price));
                        self.order.summary = parseInt(self.shop_cart.summary) + parseInt(self.deliveries[i].calculate_price);
                    }
                }
            }

            self.send_order = function () {

                self.desabled_btn = true;
                self.btn_text = 'Отправляется...';

                self.order.cart = self.shop_cart.id;
                //self.order.summary = self.shop_cart.summary;

                self.order.$save(
                    function (response, code) {

                        ym(44803777, 'reachGoal', 'ORDER_SEND');

                        if (self.order.payment == 3) {
                            self.order_check = 'payment-card';
                            self.order_result_message = 'Ваш заказ успешно отправлен! сейчас вы будете перенаправлены на страницу оплаты';
                            $window.location.href = self.order.payment_form_url;
                        }
                        else {
                            self.order_check = 'complete';
                        }

                        self.desabled_btn = false;
                        self.btn_text = 'Отправить заказ';
                    },
                    function (response, code) {
                        self.errors_order = response.data;
                        self.desabled_btn = false;
                        self.btn_text = 'Отправить заказ';
                    }
                );
            }
        }]
    })

    .component('paymentresult', {
        templateUrl: angularTemplatesBase+'shop/paymentresult.template.html?v=1',
        controller: ['$routeParams', '$location', '$cookies', '$interval', 'UserPayment', function PaymentResultCtrl($routeParams, $location, $cookies, $interval, UserPayment) {
            var self = this;
            self.status_text = "в процессе";
            self.status_class = '';

            var tryCounter = 0


            var interval_func = $interval(function() {

                tryCounter++

                self.payment = UserPayment.get({}, function(){
                    self.status_text = self.payment.error_message;
                    if(self.payment.order_status == 2){
                        self.status_class = 'text-success';
                        $interval.cancel(interval_func);
                    }
                    else{
                        self.status_class = 'text-error';
                    }

                }, function(response) {
                    console.log(response)
                });

                if (tryCounter > 10) {
                    $interval.cancel(interval_func);
                    self.status_text = "Произошла ошибка при проверке оплаты. Если деньги списались с карты, обратитесь к менеджеру магазина.";
                }
                    
            }, 2000)

        }]
    })

    .component('paymentstatusyookassa', {
        bindings: {
            paymentid: '@'
        },
        templateUrl: angularTemplatesBase+'shop/payment_status_yookassa.template.html',
        controller: ['$routeParams', '$location', '$cookies', '$interval', 'UserPaymentYooKassa', function PaymentStatusYookassaCtrl($routeParams, $location, $cookies, $interval, UserPaymentYooKassa) {
            this.$onInit = function () {
                var self = this;
                console.log(self.paymentid);

                self.show_progress = true;
                self.payment_result = false;
                self.counter = 0;
                self.result_class = '';
                self.message = '';
                self.description = '';

                var interval_func = $interval(function(){
                    console.log('Check status payment');

                    self.payment = UserPaymentYooKassa.get({objectId:self.paymentid},
                        function(response){

                            console.log(self.payment);

                            if (self.payment.notification){
                                $interval.cancel(interval_func);
                                self.show_progress = false;
                                self.payment_result = true;
                                if(self.payment.status == 'waiting_for_capture') {
                                    self.result_class = 'text-success';
                                    self.message = 'Оплата прошла успешно!';
                                    self.description = 'Сумма была заморожена на вашей карте. После подтверждения наличия товара деньги будут списаны. Если выбранный товар уже продан, сумма будет разблокирована.';
                                }
                                if(self.payment.status == 'succeeded') {
                                    self.result_class = 'text-success';
                                    self.message = 'Оплата прошла успешно!';
                                    self.description = '';
                                }
                                if(self.payment.status == 'canceled') {
                                    self.result_class = 'text-error';
                                    self.message = 'Оплата отменена или произошла ошибка';
                                    self.description = 'Попробуйте повторить попытку позднее';
                                }
                            }
                            
                            if (self.counter > 20) {
                                $interval.cancel(interval_func);
                                self.payment_result = true;
                                self.show_progress = false;
                                self.result_class = 'text-error';
                                self.message = 'Не удалось проверить статус платежа';
                                self.description = 'При проверке оплаты произошла ошибка. Если списание произошло, деньги вернутся на вашу карту.';
                            }
                            self.counter++;
                        },
                        function(response){
                            console.log(response);
                        }
                    )

                }, 3000);

            }
            
        }]
    })

    .component('shop', {
        templateUrl: angularTemplatesBase+'shop/shop.template.html',
        controller: ['$routeParams', '$location', '$cookies', 'Product', function ShopCtrl($routeParams, $location, $cookies, Product) {
            var self = this;
            var partSlug = $location.path().replace(/^\/|\/$/g, '').split('/').pop();
            self.products = Product.query({partSlug: partSlug});
        }]
    })
    .component('comparecart', {
        templateUrl: angularTemplatesBase+'shop/compare_cart.template.html?2',
        controller: ['$routeParams', '$location', '$cookies', 'CompareCartService', function CompareCartCtrl($routeParams, $location, $cookies, CompareCartService) {
            var self = this;
            self.staticBase = staticBase;
            self.compare_cart = CompareCartService.getCart();
        }]
    })
    .component('comparepage', {
        templateUrl: angularTemplatesBase+'shop/compare_page.template.html?3',
        controller: ['$routeParams', '$location', '$cookies', 'CompareCartService', function ComparePageCtrl($routeParams, $location, $cookies, CompareCartService) {
            this.$onInit = function () {
                var self = this;

                self.compare_cart = CompareCartService.getCart();

                self.delete_item = function (item) {
                    var index_del = -1;
                    for (var i = 0; i < self.compare_cart.items.length; i++) {
                        if (self.compare_cart.items[i].object_id == item.object_id) {
                            index_del = i;
                            continue;
                        }
                    }
                    if (index_del > -1) {
                        self.compare_cart.items.splice(index_del, 1);
                    }
                    self.compare_cart.$update(function (response, code) {
                        CompareCartService.setCart(response);
                    }, function (response, code) {
                    });
                }
            }
        }]
    });

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}